var React = require('react');

function Now (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 6a1 1 0 1 0-2 0h2Zm-1 6h-1a1 1 0 0 0 .553.894L12 12Zm3.553 2.894a1 1 0 1 0 .894-1.788l-.894 1.788ZM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11h-2Zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11v-2Zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12h2Zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11v2Zm-1 3v6h2V6h-2Zm.553 6.894 4 2 .894-1.788-4-2-.894 1.788Z","fill":"#0F0F0F"}));
}

Now.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Now;

Now.default = Now;
